import React from 'react';
import classNames from 'classnames';
import { Icon } from '@doxyme/ui';
import { FormattedMessage } from "react-intl";
export function SignUpStepper({ steps, currentStepIndex }) {
    return (<div className="sign-up__stepper-container">
      {steps.map((stepLabel, index) => {
            const isCompleted = index < currentStepIndex;
            const isCurrent = index === currentStepIndex;
            return (<React.Fragment key={index}>
              <div className="sign-up__step-container">
                {/* Step circle */}
                <div className={classNames({
                    'sign-up__step-circle--inactive': !isCurrent,
                    'sign-up__step-circle--active': isCurrent
                })}>
                  {isCompleted ? (<Icon name="stepper-check-mark"/>) : (index + 1)}
                </div>

                <div className={classNames({
                    "sign-up__step-text--inactive": !isCurrent,
                    "sign-up__step-text--active": isCurrent
                })}>
                  <FormattedMessage id={stepLabel}/>
                </div>
              </div>

              {index < steps.length - 1 && <div className="sign-up__step-vector"/>}
            </React.Fragment>);
        })}
    </div>);
}
